import PropTypes from 'prop-types';
import { useFormik } from 'formik';
// @mui
import { styled } from '@mui/material/styles';
import { Input, Divider, IconButton } from '@mui/material';
// utils
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: 56,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  paddingLeft: theme.spacing(2),
}));

// ----------------------------------------------------------------------

ChatMessageInput.propTypes = {
  disabled: PropTypes.bool,
  onSend: PropTypes.func,
};

export default function ChatMessageInput({ disabled, onSend }) {
  const formik = useFormik({
    initialValues: { mensaje: '' },
    onSubmit: ({ mensaje }, { resetForm }) => {
      onSend(mensaje);
      resetForm();
    },
  });

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      formik.handleSubmit();
    }
  };

  return (
    <RootStyle>
      <Input
        name="mensaje"
        disabled={disabled}
        fullWidth
        value={formik.values.mensaje}
        disableUnderline
        onKeyUp={handleKeyUp}
        onChange={formik.handleChange}
        placeholder="Escribe un mensaje"
      />

      <Divider orientation="vertical" flexItem />

      <IconButton
        color="primary"
        disabled={!formik.values.mensaje}
        onClick={formik.handleSubmit}
        sx={{ mx: 1 }}
      >
        <Iconify icon="ic:round-send" width={22} height={22} />
      </IconButton>
    </RootStyle>
  );
}
